export enum USER_STATUS {
  PENDING = 'PENDING',
  ACTIVATED = 'ACTIVATED',
}
